
<template>
  <div v-if="dados && type && dados.length">
    <div class="alert mb-2" 
        :class="( 'border-' + types[type_from_order(order)].color ) + ( order.fl_suspensa ? ' alert-secondary' : ' alert-light' )" 
         v-for="(order, index) in tratar_edicoes(dados)" :key="index">

        <div v-if="exibir_medico">
            <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
            {{ order.anamnese.atendimento_procedimento.atendimento.medico.st_nome_exibicao }}
            em 
            {{ $util.getFormatDate(order.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
        </div>

        <template v-if="!imprimindo && !view_only">
            <span class="close" v-if="1==1 || $store.state.user.id_usuario == 1" title="Log de Alterações">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="$util.logAudit(order.model.type, order.model.id)">
                    <i class="fas fa-question-circle"></i>
                </a>
            </span>

            <span class="close" v-if="order.doc_certificado && order.doc_certificado_link" title="Cancelar documento">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(order)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                </a>
            </span>
            
            <span class="close" v-if="order.doc_certificado && callback_compartilhar">
                <a href="#" @click.prevent="callback_compartilhar(order)" class="alert-link mr-1 ml-2" target="_blank" title="Compartilhar">
                    <i class="fa fa-share" aria-hidden="true"></i>
                </a>
            </span>

            <span class="close" v-if="order.doc_certificado && order.doc_certificado_link" title="Imprimir">
                <a :href="order.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
                    <i class="fas fa-file-contract"></i>
                </a>
            </span>
            <span class="close" v-else-if="order.doc_certificado" title="Imprimir">
                <a href="#" @click.prevent="imprimir(order, true)" class="alert-link mr-1 ml-2" target="_blank">
                    <i class="fas fa-file-contract"></i>
                </a>
            </span>
            <span class="close" v-else-if="!block_ass && order_pode_assinar(order)" title="Assinar">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar(order)">
                    <i class="fas fa-signature"></i>
                </a>
            </span>
            <span class="close" v-if="order.st_prescricao_memed">
                <a href="#" class="alert-link mr-1 ml-2 text-info" @click.prevent="memed(order)">
                    <i class="fas fa-medkit"></i>
                </a>
            </span>
            <span class="close" v-if="!order.st_prescricao_memed">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="imprimir(order)">
                    <i class="fas fa-print"></i>
                </a>
            </span>

            <span class="close" v-if="order.id_solicitacao_autorizacao && tem_apac(order)">
                <a href="#" class="alert-link mr-1 ml-2" title="Assinar Solicitação de Autorização" @click.prevent="assinar_lea(order)" v-if="!tem_apac_certificado(order)">
                    <i class="fa-solid fa-file-signature"></i>
                </a>

                <a href="#" class="alert-link mr-1 ml-2" title="Solicitação de Autorização (LEA) assinada" @click.prevent="lea_assinada()" v-else>
                    <i class="fa-solid fa-file-circle-check"></i>
                </a>
            </span>

            <span class="close" v-if="order.id_solicitacao_autorizacao">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="imprimir_aut(order)">
                    <i class="fas fa-stamp"></i>
                </a>
            </span>

            <span class="close" v-if="order.fl_prescricao && solmatmed">
                <a href="#" class="alert-link mr-1 ml-2" :class="order.solicitacao ? 'text-success' : ''" title="Solicitar Mat/Med." @click.prevent="solicitar_matmed(order)">
                    <i class="fa-solid fa-boxes-packing"></i>
                </a>
            </span>
            <span class="close" v-if="order.fl_prescricao && atendimento && atendimento.prescricao_cobranca">
                <a href="#" class="alert-link mr-1 ml-2" title="Cobrança." @click.prevent="ver_detalhe_cobranca(order)">
                    <i class="fa-solid fa-dollar-sign"></i>
                </a>
            </span>
            <span class="close" v-if="atendimento && ( atendimento.delegado || $store.state.user.id_pessoa == ( order.id_medico ? order.id_medico : atendimento.id_medico ) ) && !order.st_prescricao_memed">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="editar(order)">
                    <i :class="types[type_from_order(order)].icon"></i>
                </a>
            </span>

            <span class="close" v-if="order.fl_prescricao && callback_calc_peso_altura">
                <a href="#" class="alert-link mr-1 ml-2" title="Aferição Peso/Altura." @click.prevent="callback_calc_peso_altura(order)">
                    <i class="fa-solid fa-weight-scale"></i>
                </a>
            </span>

            <span class="close" v-if="order.fl_prescricao && order.contatos_count">
                <a href="#" class="alert-link mr-1 ml-2" title="Validação da Prescrição." @click.prevent="ver_contatos(order)">
                    <i class="fa-solid fa-comment"></i>
                </a>
            </span>

            <span class="close" v-if="order.fl_prescricao">
                <a href="#" class="alert-link mr-1 ml-2" title="Horários de Aplicação." @click.prevent="toggle_ver_peso(order)">
                    <i class="fa-solid fa-clock"></i>
                </a>
            </span>
        </template>

        <template v-else-if="view_only">

            <!-- Apenas Visualização -->

            <span class="close" v-if="order.doc_certificado && order.doc_certificado_link" title="Imprimir">
                <a :href="order.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
                    <i class="fas fa-file-contract"></i>
                </a>
            </span>

            <span class="close" v-if="order.fl_prescricao">
                <a href="#" class="alert-link mr-1 ml-2" title="Horários de Aplicação." @click.prevent="toggle_ver_peso(order)">
                    <i class="fa-solid fa-clock"></i>
                </a>
            </span>

        </template>

        <div>
            <div>
                <a href="#" @click.prevent="toggle_hide_order(order)" class="alert-link d-print-none mr-2" title="Exibição">
                    <i class="far fa-minus-square" v-if="!order.hide"></i>
                    <i class="far fa-plus-square" v-else></i>
                </a>
                <template v-if="order.hide">
                    <span>
                        <span v-if="order.titulo && order.fl_ciclos" class="mr-3">
                            {{ order.titulo }}
                        </span>
                        <span v-else>
                            {{ order.items.length }} {{ order.items.length > 1 ? 'itens' : 'item' }}
                        </span>

                        <span v-if="order.dt_valid_ini && order.dt_valid_fim" class="small" title="Validade da Prescrição" :class="( order.dt_valid_ini <= $util.hoje_com_hora() && order.dt_valid_fim > $util.hoje_com_hora() ) ? 'font-weight-bold text-dark' : 'text-muted'">
                            | {{ $util.getFormatDate(order.dt_valid_ini, 'DD/MM') }} {{ order.dt_valid_ini.slice(11,16) }} 
                            a {{ $util.getFormatDate(order.dt_valid_fim, 'DD/MM') }} {{ order.dt_valid_fim.slice(11,16) }}
                        </span>
                    </span>
                    <div class="row">
                        <div class="col col-12 text-truncate">
                            <span class="small text-muted text-truncate ml-3">
                                {{ order.items.map(item => item.item.search
                                    + ( ( item.diluidos && item.diluidos.length ) 
                                        ? ' (+ ' + item.diluidos.map(dil => dil.item.search).join(', ') + ')'
                                        : '' 
                                    )
                                ).join(', ') }}
                            </span>
                        </div>
                    </div>
                </template>
                <template v-else-if="imprimindo">
                    {{ types[type_from_order(order)].title }} | {{ $util.getFormatDate(order.dt_inclusao) }} {{ order.dt_inclusao.substr(11,5) }}
                </template>
                <template v-else-if="order.fl_prescricao">
                    <span class="badge badge-secondary mr-3" v-if="order.in_duracao && order.in_duracao > 1 && !order.dt_valid_ini">
                        {{ order.in_duracao }} {{ order.in_duracao > 1 ? 'dias' : 'dia' }}
                    </span>
                    <span v-if="order.dt_inclusao" class="small text-muted">
                        {{ types[type_from_order(order)].title }} | {{ $util.getFormatDate(order.dt_inclusao) }} {{ order.dt_inclusao.substr(11,5) }}
                    </span>
                    <span v-if="order.dt_valid_ini && order.dt_valid_fim" class="small" title="Validade da Prescrição" :class="( order.dt_valid_ini <= $util.hoje_com_hora() && order.dt_valid_fim > $util.hoje_com_hora() ) ? 'font-weight-bold text-dark' : 'text-muted'">
                        | {{ $util.getFormatDate(order.dt_valid_ini, 'DD/MM') }} {{ order.dt_valid_ini.slice(11,16) }} 
                        a {{ $util.getFormatDate(order.dt_valid_fim, 'DD/MM') }} {{ order.dt_valid_fim.slice(11,16) }}
                    </span>
                </template>
                <template v-else>
                    <span v-if="order.dt_inclusao" class="small text-muted">
                        {{ types[type_from_order(order)].title }} | {{ $util.getFormatDate(order.dt_inclusao) }} {{ order.dt_inclusao.substr(11,5) }}
                    </span>
                </template>
                

                <span v-if="atendimento && order && !order.hide && order.id_medico && order.medico_edicao" class="text-muted small ml-2">
                    {{ order.medico_edicao.search }}
                </span>
            </div>
        </div>

        <div v-show="!order.hide">
            <table class="table table-sm mb-0" v-show="!order.hide">
                <tr v-if="order.titulo"> <!-- && !order.fl_prescricao -->
                    <td colspan="2">
                        <div class="d-flex justify-content-between">
                            <span>
                                <span class="small mr-1">{{ order.titulo }}</span>
                                <template v-if="order.kit && order.kit.js_classes && order.kit.js_classes.length">
                                    <span v-for="(classe, icx) in order.kit.js_classes" :key="icx" class="badge badge-secondary ml-1">{{ classe }}</span>
                                </template>
                                <template v-if="order.id_receita_base">
                                    <span class="badge badge-secondary ml-1">Editada</span>
                                </template>
                            </span>
                            <small v-if="order.in_ciclos">Ciclos {{ order.in_ciclos }}</small>
                        </div>
                    </td>
                </tr>
                <tr v-if="order.plano">
                    <td colspan="2">
                    {{ order.plano.search }}
                    </td>
                </tr>
                <tr v-if="order.cid">
                    <td colspan="2">
                    CID: {{ order.cid.st_codigo }}
                    <a href="#" class="card-link" @click.prevent="copiar_clipboard(order.cid.st_codigo.substr(0,5), 'CID')">
                        <i class="far fa-copy ml-1"></i>
                    </a>
                    <span v-if="order.cid2 && order.cid2.st_codigo">
                        / {{ order.cid2.st_codigo }}
                    </span>
                    <span v-if="order.cid3 && order.cid3.st_codigo">
                        / {{ order.cid3.st_codigo }}
                    </span>
                    </td>
                </tr>
                <template v-for="(grupo_items, grupo, igx) in agrupados(order)">
                    <tr v-if="grupo || igx"  :key="'T' + igx">
                    <td colspan="2">
                        <div class="d-flex flex-column mt-2">
                        <span class="badge badge-secondary">
                            {{ grupo ? grupo : 'Outros' }}
                        </span>
                        </div>
                    </td>
                    </tr>
                    <template v-for="(item, idm) in grupo_items">
                        <tr :key="igx + '-' + idm" :class="( !filtrar_dia || teste_dia(item) ) ? '' : 'text-muted text-line-through'" v-if="true">
                            <td width="1%" class="border-0" :class="tamanho == 'P' ? 'py-0' : ''">
                                <i class="fa fa-caret-right" aria-hidden="true"></i> 
                            </td>
                            <td class="border-0" :class="tamanho == 'P' ? 'py-0' : ''">
                                <span v-if="item.diluidos && item.diluidos.length" :class="tamanho == 'P' ? 'small' : ''">
                                    <template v-for="(diluido, idx) in item.diluidos">
                                        <div :key="idx" :class="( !filtrar_dia || teste_dia(diluido) ) ? '' : 'text-muted text-line-through'" v-if="true">
                                            <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                                            {{ diluido.item.search }}
                                            <span v-if="diluido.in_quantidade">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span class="text-muted">{{ diluido.in_quantidade }}{{ diluido.apresentacao ? ' ' + diluido.apresentacao.search : 'x' }}</span>
                                                <span v-if="diluido.qtd_calc">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                                </span>
                                            </span>

                                            <span v-if="diluido.st_ciclo_dias">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span class="text-muted">{{ diluido.st_ciclo_dias }}</span>
                                            </span>

                                            <span v-if="diluido.st_observacoes">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                <span class="text-muted">{{ diluido.st_observacoes }}</span>
                                            </span>
                                        </div>
                                    </template>
                                </span>
                                <span :class="tamanho == 'P' ? 'small' : ''">
                                    <span v-if="false && item.diluidos && item.diluidos.length">diluído em </span>
                                    {{ item.item.search }} <span class="badge badge-danger ml-1" v-if="item.fl_suspenso">Suspenso</span>
                                    <span v-if="item.in_quantidade">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <span class="text-muted">{{ item.in_quantidade }}{{ item.apresentacao ? ' ' + item.apresentacao.search : 'x' }}</span>
                                        <span v-if="item.qtd_calc">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <span class="text-muted">{{ item.qtd_calc }}</span>
                                        </span>
                                    </span>
                                    <span v-if="item.st_ciclo_dias">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        <span class="text-muted">{{ item.st_ciclo_dias }}</span>
                                    </span>
                                    <span class="text-muted" style="white-space: pre-wrap;" v-html="item.complemento"></span>
                                </span>

                                <div v-if="order.fl_prescricao && item.fl_info_datas && item.dt_inicio_trat && item.dt_fim_trat" class="text-muted">
                                    Período: {{ $util.getFormatDate(item.dt_inicio_trat) }} a {{ $util.getFormatDate(item.dt_fim_trat) }}
                                </div>

                                <div v-if="item.cassetes && item.cassetes.length">
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between py-2 hover-bg" v-for="(cassete, icx) in item.cassetes" :key="icx">
                                            <div v-if="cassete.amostra">
                                                {{ cassete.amostra.st_titulo }}
                                                <span class="small text-muted ml-2">
                                                    {{ cassete.amostra.st_codigo }}
                                                </span>
                                            </div>
                                            <div>
                                                {{ cassete.js_classes ? cassete.js_classes.join(', ') : '' }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="order.fl_prescricao && order.ver_peso">
                                    <table class="table table-sm small text-muted mt-1" v-if="item.js_prescricao_horarios && item.js_prescricao_horarios.horarios && item.js_prescricao_horarios.horarios.length">
                                        <thead>
                                            <tr v-for="(horario, ihx) in item.js_prescricao_horarios.horarios" :key="ihx">
                                                <td width="3%">
                                                    <a href="#" @click.prevent="aplicar(order)" title="Registrar Aplicação">
                                                        <i :class="icon_hora_status(horario)" :title="texto_hora_status(horario)"></i>
                                                    </a>
                                                </td>
                                                <td width="17%">
                                                    <template v-if="horario.hora && horario.hora.length > 10">
                                                        {{ $util.getFormatDate(horario.hora) }} {{ horario.hora.substr(11,5) }}
                                                    </template>
                                                    <template v-else>
                                                        {{ horario.hora }}
                                                    </template>
                                                </td>
                                                <td width="40%">
                                                    <span v-if="horario.responsavel_atualizacao">
                                                        por
                                                        <template v-if="!Array.isArray(horario.responsavel_atualizacao)">
                                                            {{ $util.ucwords(horario.responsavel_atualizacao) }}
                                                        </template>
                                                        <template v-else
                                                            v-for="(responsavel, index) in horario.responsavel_atualizacao">
                                                            {{ index > 0 ? ' e ' : '' }}{{
                                                            $util.ucwords(responsavel.st_nome) }}

                                                            <span v-if="responsavel.conselho && responsavel.numero" :key="'c' + index" class="small text-muted ml-1">
                                                                {{ responsavel.conselho }} {{ responsavel.numero }}
                                                            </span>
                                                        </template>
                                                    </span>
                                                </td>
                                                <td width="40%">
                                                    {{ horario.obs }}
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>

                                    <div class="small text-muted mt-1" v-else>
                                        Nenhum horário aprazado.
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </template>
                <tr v-if="order.in_peso && callback_calc_peso_altura"> 
                    <td colspan="2" class="table-secondary small">
                    <div class="d-flex justify-content-between">
                        <div>
                        <span>Peso: {{ $util.formatMoeda(order.in_peso, 1) }} kg</span>
                        <span v-if="order.in_altura">
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            Altura: {{ $util.formatMoeda(order.in_altura) }} m
                        </span>
                        <span v-if="order.in_altura">
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            SC: {{ $util.formatMoeda($util.calc_sup_corp(order.in_peso, order.in_altura)) }} m2
                        </span>
                        <span v-if="order.dc_creatinina">
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            Creatinina: {{ order.dc_creatinina }} mg/dL
                        </span>
                        </div>
                        <div v-if="order.dt_pesagem" class="text-muted">
                        {{ $util.getFormatDate(order.dt_pesagem) }}
                        </div>
                    </div>
                    </td>
                </tr>
                <tr v-if="order.fl_prescricao && order.ver_peso && pode_aprazar">
                    <td colspan="2">
                    <a href="#" class="mr-3" @click.prevent="aprazar(order)" title="Aprazar" data-toggle="tooltip" data-placement="top">
                        <i class="fa-solid fa-alarm-plus"></i>
                    </a>

                    <a href="#" class="mr-3" @click.prevent="aprazar(order)" title="Registrar Aplicação" data-toggle="tooltip" data-placement="top" v-if="false">
                        <i class="fa-solid fa-clipboard-check"></i>
                    </a>
                    </td>
                </tr>
            </table>

            <div v-if="order.st_observacoes" class="small text-dark mt-2" style="white-space: pre-wrap;">{{ order.st_observacoes }}</div>

            <div v-if="order.st_observacoes_interno" class="alert alert-secondary text-dark mt-2 mb-1 py-2 d-flex justify-content-between">
                <div class="small" style="white-space: pre-wrap;">{{ order.st_observacoes_interno }}</div>
                <div><i class="fas fa-thumbtack"></i></div>
            </div>
        </div>
      
    </div>

    <!-- Detalhe Cobrança -->
    <div class="modal fade" id="detalheCobrancaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" v-if="type == 'receita'">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detalhe Cobrança</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-hover" v-if="detalhe_cobranca">
              <thead>
                <tr>
                  <th>Medicamento</th>
                  <th>Qtde</th>
                  <th>Cobrança Id</th>
                  <th>Procedimento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item_cobranca, iix) in detalhe_cobranca.flat_items" :key="iix">
                  <td>
                    {{ item_cobranca.item.search }}
                    <span class="badge badge-secondary ml-1">#{{ item_cobranca.id_medicamento }}</span>
                    <span class="badge badge-warning ml-1" v-if="item_cobranca.item.unidade && !item_cobranca.item.unidade.fl_ativo" title="Inativo">
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    </span>
                    <span class="badge badge-warning ml-1" v-if="!item_cobranca.item.unidade" title="Não disponível para faturamento">
                      <i class="fa-solid fa-triangle-exclamation"></i>
                    </span>
                  </td>
                  <td>
                    {{ item_cobranca.in_quantidade }}{{ item_cobranca.apresentacao ? ' ' + item_cobranca.apresentacao.search : '' }}
                  </td>
                  <template v-if="item_cobranca.consumo">
                    <td>
                      {{ item_cobranca.consumo.id_atendimento_procedimento }}
                    </td>
                    <td>
                      {{ item_cobranca.consumo.atendimento_procedimento.procedimento.search }}
                      <span class="badge badge-danger" v-if="!item_cobranca.consumo.atendimento_procedimento.fl_ativo">Cancelado</span>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <ver-contatos ref="ver_contatos" />

  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import VerContatos from './VerContatos.vue';

export default {
  data() {
    return {
      detalhe_cobranca: null, 
      types: {
        receita: {
          color: "success",
          icon: "fas fa-prescription",
          title: 'Receita',
        },
        requisicao: {
          color: "info",
          icon: "fas fa-heartbeat",
          title: 'Requisição',
        },
        prescricao: {
          color: "primary",
          icon: "fas fa-pills",
          title: 'Prescrição',
        },
        cirurgia: { 
          color: "info",
          icon: "fas fa-procedures",
          title: 'Solicitação de Cirurgia',
        },
        consulta: { 
          color: "info",
          icon: "fas fa-stethoscope",
          title: 'Solicitação de Consulta',
        },
      }
    };
  },

  props: [
    "dados", 
    "type", 
    "atendimento", 
    "tamanho", 
    "exibir_medico", 
    "imprimindo", 
    "solmatmed", 
    "pep", 
    "callback_calc_peso_altura", 
    "callback_compartilhar",
    "view_only",
    "filtrar_dia",
    "pode_aprazar", 
    "block_ass", 
  ],

  components: { 
    VerContatos, 
  },

  computed: { 
    pode_assinar: function () { 
      let id_medico;
      let medico = this.$store.state.user.medico;

      if ( !medico && this.atendimento ) { 
        if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == this.atendimento.medico.id_pessoa) ) { 
          id_medico = this.atendimento.medico.id_pessoa;
        }
      } else { 
        id_medico = this.$store.state.user.id_pessoa;
      }

      return this.atendimento && this.atendimento.medico.id_pessoa == id_medico; // && this.atendimento.medico.tem_certificado 
    },

  },

  methods: { 
    tem_aprazamento (order) { 
        if ( !order || !order.items )
            return false;
        
        return order.items.find(item => item.js_prescricao_horarios && item.js_prescricao_horarios.horarios && item.js_prescricao_horarios.horarios.length)
            ? true : false;
    },

    tratar_edicoes (lista) { 
        if ( !lista )
            return []; 
        
        return _.map(lista, order => order.editada ? order.editada : order);
    },

    aprazar (receita) { 
      if ( this.pode_aprazar ) { 
        console.log('aprazar', receita);
        this.$parent.aprazar(receita);
      }
    },

    aplicar (receita) { 
      if ( this.pode_aprazar ) { 
        console.log('aplicar', receita);
        this.$parent.aplicar(receita);
      }
    },

    toggle_ver_peso (order) { 
        order.ver_peso = !order.ver_peso;
        this.$forceUpdate();
    },

    order_pode_assinar(order) { 
        if ( !this.atendimento ) { 
            return false;
        }

        let id_medico_order = order.id_medico ? order.id_medico : ( ( this.atendimento && this.atendimento.medico ) ? this.atendimento.medico.id_pessoa : null );

        if ( !id_medico_order )
            return false;

        let id_medico;
        let medico = this.$store.state.user.medico;

        if ( ( !medico || ( medico && medico.id_pessoa != id_medico_order ) ) && this.atendimento ) { 
            if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == id_medico_order) ) { 
              id_medico = id_medico_order;
            }
        } else { 
            id_medico = this.$store.state.user.id_pessoa;
        }

        return this.atendimento && id_medico_order == id_medico; // && this.atendimento.medico.tem_certificado 
    },

    teste_dia (item) { 
        if ( this.atendimento && this.atendimento.marcacao && this.atendimento.marcacao.in_qt_dia ) { 

            let dia = this.atendimento.marcacao.in_qt_dia;

            if ( item.lista_dias && item.lista_dias.length ) { 
                return item.lista_dias.find(item => item == dia) ? true : false;
            }
            
        }

        return true; 
    },

    texto_hora_status (horario) { 
        if ( !horario && !horario.status )
            return;

        switch (horario.status) {
            case 'A': return 'Aberto';
            case 'X': return 'Checado';
            case 'R': return 'Rejeitado';
            case 'C': return 'Cancelado';
            case 'S': return 'Suspenso';
        }
    },

    icon_hora_status (horario) { 
        if ( !horario && !horario.status )
            return;

        switch (horario.status) {
            case 'A': return 'fa fa-question-circle';
            case 'X': return 'fa fa-check-circle text-success';
            case 'R': return 'fa fa-exclamation-circle text-warning';
            case 'C': return 'fa fa-times-circle text-danger';
            case 'S': return 'fa fa-ban text-danger';
        }
    },

    lea_assinada() { 
      this.$toast.add({
        severity: "success",
        summary: "Atenção",
        detail: "Solicitação de Autorização (LEA) já assinada.",
        life: 3000
      });
    },

    tem_apac (order) { 
      return order.items.find(item => item.solicitacao_autorizacao && item.solicitacao_autorizacao.fl_apac) ? true : false;
    },

    tem_apac_certificado (order) { 
      return order.items.find(item => item.solicitacao_autorizacao 
        && item.solicitacao_autorizacao.fl_apac 
        && item.solicitacao_autorizacao.arquivos 
        && item.solicitacao_autorizacao.arquivos.length) ? true : false;
    },

    ver_contatos (order) { 
      this.$refs.ver_contatos.abrir(order.model.type, order.model.id);
    },
    
    agrupados(order) { 
      if ( !order || !order.items ) { 
        return [];
      }

      if ( this.type == 'receita' ) { 
        
        return _.groupBy(
          _.orderBy(
            order.items,
            item => item.st_agrupa ? 2 : 1, 
          ),
          item => item.st_agrupa ? item.st_agrupa : ''
        );

      } else { 

        return { '': order.items };

      }

    },

    ver_detalhe_cobranca (order) { 
      this.detalhe_cobranca = null;
      $('#detalheCobrancaModal').modal('show');

      this.$util.load(this, { 
        service: 'pep',
        func: 'receita_detalhe_cobranca',
        parms: { 
          id_receita: order.id_receita,
          id_atendimento: this.atendimento.id_atendimento
        },
        loadTo: res => { 
          this.detalhe_cobranca = res.receita;
        }
      });
    },

    solicitar_matmed (order, outros_parms = {}) { 
        console.log('solicitar_matmed', this.atendimento);

        let solicgeral = this.$util.get_solic_geral();

        if ( solicgeral ) { 
            if ( this.atendimento && this.atendimento.marcacao && this.atendimento.paciente ) { 
              this.atendimento.marcacao.nome_paciente = this.atendimento.paciente.st_nome;
            }

            solicgeral.solicitar(
                'S', 
                { 
                    ...order, 
                    id_estoque_solicitacao: order.solicitacao ? order.solicitacao.id_estoque_solicitacao : null, 
                    marcacao: this.atendimento ? this.atendimento.marcacao : null,
                    data_aplic: ( order && order.dt_valid_ini ) ? order.dt_valid_ini : ( this.tem_aprazamento(order) ? this.$util.hoje() : null ),
                    id_centro_custo: _.get(this.atendimento, 'internacao.local.id_centro_custo'), 
                    ...outros_parms, 
                },
                () => { 
                    this.$emit('refresh');
                }
            );

        }

    },

    memed(order) {
        this.$util.atualizar(this, {
            service: "memed",
            func: "recuperar_link",
            dados: {
                id_receita: order.model.id
            },
            toast: false,
            callback: res => {
                if (res && res.msg) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: res.msg,
                        life: 3000
                    });
                }

                if (res && res.link) {
                    window.open(res.link, "_blank").focus();
                }
            }
        });

    },

    toggle_hide_order(order) { 
      order.hide = !order.hide;
      this.$forceUpdate();
    },

    toggle_hide_order_all(compress = true) { 
      if ( !this.dados ) 
        return;

      this.dados.forEach(order => {
        order.hide = compress;
      });
      
      this.$forceUpdate();
    },

    copiar_clipboard (text, titulo = null) { 
      if (!navigator.clipboard) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position="fixed";  //avoid scrolling to bottom
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      } else { 
        navigator.clipboard.writeText(text).then(function() {
          console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
          console.error('Async: Could not copy text: ', err);
        });
      }

      this.$toast.add({
        severity: "success",
        summary: "Atenção",
        detail: ( titulo ? titulo : 'Texto' ) + " copiado para a área de transferência.",
        life: 3000
      });
    },

    type_from_order(order) { 
      return order.fl_prescricao 
        ? 'prescricao' 
        : ( order.fl_cirurgia 
          ? 'cirurgia' 
          : ( order.fl_consulta ? 'consulta' : this.type )
        );
    },

    lista_items(order) { 
      if ( !order )
        return [];

      if ( order.model.type == 'requisicao' )  
        return _.orderBy(order.items, 'item.search');

      return order.items
    },

    imprimir(order, cert = false) { 
      if ( this.pep ) { 
        this.$util.print_preview('imprimir/' + ( cert ? 'doc_certificado/' : '' ) + order.model.type + '/' + order.model.id, true, { noass: 1 }, true);  
      } else { 
        this.$util.print_preview('imprimir/' + ( cert ? 'doc_certificado/' : '' ) + order.model.type + '/' + order.model.id, true);
      }
    },

    imprimir_aut(order) { 
      this.$util.print_preview('imprimir/solic_autoriz/' + order.id_solicitacao_autorizacao);
    },

    cancelar(order) { 
      if ( !confirm("Confirma cancelar esse registro assinado?") ) 
        return;

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'item_remover', 
        dados: { 
          model_type: order.model.type,
          model_id: order.model.id,
        },
        callback: () => { 
          this.$emit('refresh', null);
        }
      });
    
    },

    editar (order) { 
      if ( order.doc_certificado ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Editar",
          detail: "Documento já assinado. Edição não disponível.",
          life: 3000
        });
      } else { 
        this.$emit('editar', order);
      }
    },

    assinar_lea (order) { 
      console.log('lea', order);

      this.$emit(
        'assinar', 
        { 
          id_anamnese: order.id_anamnese,
          model: { 
            type: 'solicAutLea',
            id: order.id_solicitacao_autorizacao,
          }
        }
      );
    },
    
    assinar (order) { 
      this.$emit('assinar', order);
    }
  }

};
</script>

<style scoped>
.text-line-through {
    text-decoration: line-through !important;
}
</style>
